<template>
  <a-spin :spinning="loading">
    <vxe-grid
        ref="xGrid"
        column-key
        class="column-sortable-grid"
        v-bind="gridOptions"
        @cell-dblclick="cellDbClick"
        :auto-resize="true"
    >
      <template v-slot:default="{ row }">
        <slot name="operate" v-bind:row="row"></slot>
      </template>
      <template v-slot:toolbar_buttons>
        <slot v-if="toolbarConfig&&toolbarConfig.templatelSlots"
              :name="toolbarConfig&&toolbarConfig.templatelSlots"></slot>
      </template>

    </vxe-grid>
  </a-spin>
</template>

<script>
import Vue from "vue";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

import VXETablePluginAntd from 'vxe-table-plugin-antd';
import 'vxe-table-plugin-antd/dist/style.css';
import XEUtils from "xe-utils";
import {treeList} from "@/services/dataSource";

VXETable.use(VXETablePluginAntd);

Vue.use(VXETable);

/**
 * 如果value值有效(除了null/undefined/NaN之外的所有值)则返回value，否则返回defaultValue
 * @param value
 * @param defaultValue
 * @returns
 */
function valueOrDefault(value, defaultValue) {
  return typeof value === "undefined" || value === null || isNaN(value)
      ? defaultValue
      : value;
}

/**
 * 工厂方法，用来提供各种设置的默认值
 */
const factory = {
  /**
   * 生成一个序号列
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param width 50
   * @returns {}
   */
  makeColumnSeqDefault(width = 50) {
    return {type: "seq", title: '序号', width: width, align: "center"};
  },
  /**
   * 根据类型生成首列选择栏r>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param type 选择框内容 默认为checkbox
   * @returns {}
   */
  makeColumnDefault(type = 'checkbox') {
    if (type === 'radio') {
      return {type: "radio", field: '#', width: 50, align: "center"};
    } else {
      return {type: "checkbox", field: '#', width: 50, align: "center"};
    }
  },
  /**
   * 生成一个空的checkbox列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @returns {}
   */
  makeColumnCheckboxDefault(field = "#") {
    return {type: "checkbox", field: field, width: 50, align: "center"};
  },
  /**
   * 生成一个空的radio列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @returns {}
   */
  makeColumnRadioDefault(field = "#") {
    return {type: "radio", field: field, width: 50, align: "center"};
  },
  /**
   * 创建列定义
   * @param field 字段名，或者一个column对象（如果使用column对象，则只能传一个参数）
   * @param title 标题
   * @param width
   * @param align
   * @param resizable 是否可调整大小
   * @param formatter
   * @param type
   * @param treeNode 是否是折叠节点
   * @param slots 列插槽
   * @returns {{formatter: null, field: *, resizable: boolean, width: (*|number), sortable: boolean, filters: *[], title: *, align: string, type: null, filterMultiple: boolean}|any}
   */
  makeColumn(
      field,
      title,
      width,
      align = "left",
      resizable = true,
      formatter = null,
      type = null,
      treeNode = false,
      slots = null,
      // sortable = false,
      // filters = []
  ) {
    if (arguments.length === 1 && typeof field == "object" && field) {
      // 传入column object，则添加一些默认值
      return Object.assign(
          {
            field: field.field,
            title: field.title || field.field,
            width: field.width,
            resizable: valueOrDefault(field.resizable, true),
            headerAlign:'center'
            // sortable: valueOrDefault(field.sortable, false),
          },
          field
      );
    } else {
      // 传入参数表
      return {
        field,
        title: title || field,
        width:
            width === null || typeof width === "undefined" ? width : width || 100,
        align,
        resizable,
        formatter,
        type,
        treeNode,
        slots,
        headerAlign:'center'
        // sortable,
        // filters,
        // filterMultiple: false,
      };
    }
  },
  /**
   * 获取工具栏配置
   * @param buttons 按钮列表
   * @returns
   */
  makeToolbarConfig(buttons = {}) {
    return Object.assign({}, {
      slots: {
        buttons: 'toolbar_buttons'
      },
      refresh: false,
      import: false,
      export: false,
      print: false,
      zoom: false,
      custom: false,
    }, buttons);
  },
  /**
   * 生成列表页弹出层配置
   */
  makePopConfig(funcArr) {
    let popConfig = {};
    if (!funcArr || !funcArr.length || !Array.isArray(funcArr)) {
      return {};
    }
    funcArr.forEach(val => {
      popConfig[val] = {
        show: false,
        id: -1,
      }
    })
    return popConfig;
  },
  makeTreeConfig(param) {
    return Object.assign(
        {
          lazy: true,
          children: 'children',
          loadMethod() {

          }
        },
        param
    );
  },
  makeAjaxConfig(url, rowId, parentId) {
    return {
      query: async () => {
        // 将带层级的列表转成树结构
        let arr = await treeList(url);
        return XEUtils.toArrayTree(arr.data, {key: rowId, parentKey: parentId || 'parentId', children: 'children'})
      },
    };
  },
  makeEditConfig() {
    return {
      trigger: "click",
      mode: "row",
      showStatus: true,
    };
  },
  makeEditRuleRequired(messageOrColumn) {
    return {
      required: true,
      message:
          typeof messageOrColumn === "string"
              ? messageOrColumn
              : (messageOrColumn.title || messageOrColumn.field) + "必须填写",
    };
  },
  makeEditRuleRange(messageOrColumn, min, max) {
    return {
      min,
      max,
      message:
          typeof messageOrColumn === "string"
              ? messageOrColumn
              : (messageOrColumn.title || messageOrColumn.field) +
              `长度应在${min}-${max}字符之间`,
    };
  },
  /**
   * 根据列定义的editRules构建标准editRules配置<br>
   * @param columns 列定义 [{ field: '', editRules: [{ required: true }, { min: 0, max: 1 }, ...] }]
   * @returns { COLUMN_FILED: [ RULE1, RULE2, ... ], ... }
   */
  makeEditRules(columns) {
    const rules = {};
    columns.forEach((col) => {
      if (col.editRules) {
        if (!XEUtils.isArray(col.editRules)) {
          console.warn("列定义的editRules应是一个数组");
        } else {
          rules[col.field] = col.editRules.map((rule) => {
            if (rule) {
              const editRule = Object.assign({}, rule);
              if (typeof rule.required === "boolean") {
                editRule.message = `${col.title || col.field}必填`;
              } else if (
                  typeof rule.min === "number" ||
                  typeof rule.max === "number"
              ) {
                editRule.message = `${col.title ||
                col.field}长度应在${rule.min || 0}-${rule.max || 0}之间`;
              } else {
                console.info("不支持的editRule", rule);
              }
              return editRule;
            }
          });
        }
      }
    });
    return rules;
  },
};

/**
 * 组件定义
 */
export default {
  name: "XGrid",
  components: {},
  props: {
    id: String,
    columnResizable: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    showHeaderOverflow: {
      type: Boolean,
      default: true,
    },
    showOverflow: {
      type: Boolean,
      default: true,
    },
    highlightHoverRow: {
      type: Boolean,
      default: true,
    },
    keepSource: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      default() {
        return document.body.clientHeight - 48 - 64
      },
    },

    rowId: String,
    /**
     * 列定义
     */
    columns: Array,
    /**
     * 单元格双击时打开详情
     */
    cellDbClick: Function,
    /**
     * 工具栏配置<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/toolbar<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/customToolbar<br>
     * {
     *   buttons: [
     *     { code: 'myInsert', name: '新增', status: 'success', disabled: false },
     *     ...
     *   ],
     *   refresh: true,
     *   import: true,
     *   export: true,
     *   print: true,
     *   zoom: true,
     *   custom: true
     * }
     */
    treeConfig: Object,
    toolbarConfig: Object,
    ajaxConfig: Object,
    /**
     * 是否可编辑，如果设置为true，则默认生成单击行编辑的editConfig
     */
    editable: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    console.info("XGrid data =", this.data);
    return {
      loading: false,
      gridOptions: {
        border: this.border,
        resizable: this.columnResizable,
        showHeaderOverflow: this.showHeaderOverflow,
        showOverflow: this.showOverflow,
        highlightHoverRow: this.highlightHoverRow,
        keepSource: this.keepSource,
        id: this.id,
        height: this.height,
        rowId: this.rowId || "id",
        toolbarConfig: this.toolbarConfig,
        columns: this.columns,
        editConfig:
            this.editable || (this.editable !== false && this.editConfig)
                ? this.editConfig || factory.makeEditConfig()
                : null,

        proxyConfig: {
          ajax: this.ajaxConfig
        },
        treeConfig: this.treeConfig
      },

    };
  },
  methods: {
    insertAt(insertArr, index) {
      // console.log(insertArr, index)
      this.$refs['xGrid'].insertAt(insertArr, index);
    },
    async loadChildrenMethod({row}) {
      console.log(row)
    }
  },
  factory: factory,
};
</script>

<style scoped>
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-ghost,
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-chosen {
  background-color: #dfecfb;
}

.column-sortable-grid .vxe-header--row .vxe-header--column.col--fixed {
  cursor: no-drop;
}
</style>
